import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-neutral-950 text-neutral-900 dark:text-neutral-50 flex items-center justify-center px-6">
      <div className="text-center">
        <div className="text-[12px] uppercase tracking-[0.18em] text-neutral-400 dark:text-neutral-500">
          404
        </div>
        <h1
          className="mt-3 text-[44px] sm:text-[60px] leading-[1.05] tracking-[-0.03em] font-medium"
          style={{ fontFamily: "'Segoe Script', 'Caveat', cursive" }}
        >
          Page not found.
        </h1>
        <p className="mt-3 text-[15px] text-neutral-500 dark:text-neutral-400 max-w-[420px] mx-auto">
          The page you’re looking for doesn’t exist or was moved.
        </p>
        <Link
          to="/"
          className="mt-7 inline-flex items-center gap-2 bg-neutral-900 dark:bg-white dark:text-neutral-900 text-white px-5 py-2.5 rounded-full text-[14px] font-medium hover:bg-neutral-700 dark:hover:bg-neutral-200 transition-colors duration-200"
        >
          <ArrowLeft className="w-4 h-4" strokeWidth={2.25} />
          Back home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
